import {call, ForkEffect, put, takeLatest} from 'redux-saga/effects';
import {FETCH_LOGGED_IN_USER_ACTION} from '../actions/types/auth.types';
import {fetchLoggedInUser} from '../../service/auth.service';
import {setLoggedInUserAction} from '../actions/auth.actions';

export function* fetchLoggedInUserSaga(): Generator<void> | void {
    const loggedInUser = yield call(fetchLoggedInUser);
    yield put(setLoggedInUserAction(loggedInUser));
}

export function* watchAuthSaga(): Generator<ForkEffect<never>, void> {
    yield takeLatest(FETCH_LOGGED_IN_USER_ACTION, fetchLoggedInUserSaga);
}
